module.exports = __webpack_public_path__ + "static/preview-user-lists-scale-small-8cbe62955630bba4047303af3a5a10e3.png";